const SVGSprite = () => {
  return (
    <svg style={{ display: 'none' }}>
      <symbol id="ico-close" viewBox="0 0 10 10">
        <rect x="-1" y="4" transform="matrix(0.7071 0.7071 -0.7071 0.7071 5 -2.0711)" width="11.9" height="2" />
        <rect x="-1" y="4" transform="matrix(-0.7071 0.7071 -0.7071 -0.7071 12.0711 5)" width="11.9" height="2" />
      </symbol>
      <symbol id="ico-shopping-bag" viewBox="0 0 20 20">
        <path d="M18.4 3.32h-4.31a4.11 4.11 0 00-8.09 0H1.72V20H18.4zM10.06.91a3.22 3.22 0 013.1 2.41H7A3.23 3.23 0 0110.06.91zm7.43 18.18H2.63V4.23H6V6.1h.91V4.23h6.4V6.1h.91V4.23h3.32z" />
      </symbol>
      <symbol id="ico-arrow-left" viewBox="0 0 6.1 7">
        <path d="M2.63 7l.61-.48-2-2.64H6.1V3.1H1.2L3.26.48 2.64 0 .09 3.26a.37.37 0 000 .48z" />
      </symbol>
      <symbol id="ico-arrow-right" viewBox="0 0 6.1 7">
        <path d="M2.63 7l.61-.48-2-2.64H6.1V3.1H1.2L3.26.48 2.64 0 .09 3.26a.37.37 0 000 .48z" transform="rotate(180)" transform-origin="center center" />
      </symbol>
      <symbol id="ico-play" viewBox="0 0 31.5 36.37">
        <path d="M30.5 18.19l-15 8.66-15 8.66V.87l15 8.66 15 8.66z" />
      </symbol>
      <symbol id="ico-link" viewBox="0 0 55.5 55.5">
        <path d="M38.38 24.33a14.09 14.09 0 00-7.21-7.21L29.25 19l-1.34 1.33-1.38 1.39a5.19 5.19 0 00-.67.83 7.47 7.47 0 017 7 7.39 7.39 0 01-.37 2.91 7.49 7.49 0 01-1.73 2.89.24.24 0 00-.06.08L29.12 37l-9.52 9.53A7.6 7.6 0 018.89 35.86l5.32-5.32a16.7 16.7 0 01-.66-2.88 15.88 15.88 0 01-.17-2.18 17 17 0 01.47-4l-9.67 9.66a14.27 14.27 0 1020.17 20.18l11.1-11.1a14 14 0 002.09-2.68 14.28 14.28 0 00.84-13.21z M51.32 4.18a14.27 14.27 0 00-20.18 0L20.05 15.27A14 14 0 0018 18a14 14 0 00-2.09 7.38 14.84 14.84 0 00.36 3.18 14.2 14.2 0 00.88 2.65 14.06 14.06 0 007.22 7.21l1.91-1.92 1.34-1.33L29 33.75a5.19 5.19 0 00.67-.83 7.46 7.46 0 01-7-7A7.8 7.8 0 0123 23a7.59 7.59 0 011.74-2.89l.06-.08 11.1-11.1a7.6 7.6 0 0110.7 10.71L41.29 25a16.67 16.67 0 01.65 2.88 16.15 16.15 0 01.17 2.12 17 17 0 01-.47 4l9.68-9.67a14.27 14.27 0 000-20.18z" />
      </symbol>
      <symbol id="ico-linkedin" viewBox="0 0 32 32">
        <path d="M17 14.82zM0 0v32h32V0zm11.63 23.65H8.2V13.33h3.43zM9.92 11.92A1.77 1.77 0 018 10.14a1.79 1.79 0 011.94-1.79 1.79 1.79 0 110 3.57zM24 23.65h-3.43v-5.52c0-1.39-.5-2.34-1.74-2.34a1.89 1.89 0 00-1.76 1.26 2.35 2.35 0 00-.11.83v5.77h-3.43V13.33H17v1.46a3.41 3.41 0 013.09-1.7c2.26 0 3.95 1.47 3.95 4.64z" />
      </symbol>
      <symbol id="ico-arrow-right2" viewBox="0 0 6.7 12.6">
        <path d="M1 12.6c-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4l4.3-4.3c.1-.1.1-.3 0-.5L.3 1.7C-.1 1.3-.1.7.3.3s1-.4 1.4 0L6 4.6c1 .9 1 2.4.1 3.3l-4.3 4.3c-.3.3-.5.4-.8.4z" />
      </symbol>
      <symbol id="ico-download" viewBox="0 0 8 12.5">
        <polygon points="8,8.5 7.3,7.8 4.5,10.6 4.5,0 3.5,0 3.5,10.6 0.7,7.8 0,8.5 4,12.5 4,12.5 4,12.5 " />
      </symbol>
    </svg>
  )
}
export default SVGSprite
